import { render, staticRenderFns } from "./SaasMenu.vue?vue&type=template&id=3d1b9c57"
import script from "./SaasMenu.vue?vue&type=script&lang=js"
export * from "./SaasMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports